import {observer} from "mobx-react";
import React, {useRef} from "react";
import styles from "../NewsModal/styles/NewsModal.module.scss";
import accordionStyles from "./styles/AccordionItemModal.module.scss";
import NewsModalContentHeader from "../NewsModal/NewsModalContentHeader";
import classNames from "classnames";
import {buildAccordionItemUrl} from "../../../utils/SchoolBlocksUtilities";
import SchoolBlocksLoadingIndicator from "../../utilities/SchoolBlocksLoadingIndicator";
import Markdown from "../../utilities/Markdown";
import {useStores} from "../../../stores/useStores";

const AccordionItemModalContent = observer((props: {
    index: number,
    itemObj: IAccordionItem,
    navigationButtons?: React.ReactElement,
    closeFunction?: () => void,
    className?: string,
}) => {
    const {organizationStore} = useStores();
    const contentRef = useRef<HTMLDivElement>(null);
    const sharePathUrl = buildAccordionItemUrl(organizationStore.currentOrganization.id, props.itemObj.terrace_id, props.itemObj.id);

    const titleContainerClassName = classNames({
        [styles.titleContainer]: true,
        [accordionStyles.accordionTitle]: true,
    })

    const containerClassName = classNames({
        [styles.container]: true,
        [accordionStyles.accordionContainer]: true,
        [props.className || ""]: props.className,
    })

    return <div ref={contentRef} className={containerClassName}>
        <NewsModalContentHeader index={props.index}
                                itemObj={props.itemObj}
                                closeFunction={props.closeFunction}
                                navigationButtons={props.navigationButtons}
                                shareUrlPath={sharePathUrl}
                                printRef={contentRef}/>
        <article>
            <div className={titleContainerClassName}>
                <h2>{props.itemObj.title}</h2>
            </div>
            {props.itemObj.description && <div className={styles.content}>
                <Markdown withStyles={true} source={props.itemObj.description} />
            </div>}
            {organizationStore.organization.billing_products?.docmersion &&
                props.itemObj.has_content && <>{ props.itemObj.content_html ? <div className={styles.contentContainer}>
                <div className={classNames(styles.content, "scoped-content-builder")}>
                    <Markdown source={props.itemObj.content_html} withStyles={true}/>
                </div>
            </div> : <div className={styles.loadingIndicator}><SchoolBlocksLoadingIndicator/></div>
            }</>}
        </article>
    </div>
})

export default AccordionItemModalContent;
